import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const Radio = memo(
  ({ name, label, value, id, ...props }) => {

    return (
      <label
        className='text-slate-400 cursor-pointer flex items-center space-x-3'
        htmlFor={id}
      >
        <input
          id={id}
          name={name}
          value={value}
          type='radio'
          {...props}
        />
        <span>{label}</span>
      </label>
    );
  }
);

Radio.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.id,
}

